(function () {
    angular.module('tradersyard').component('tyInvitationsPeopleList', {
        bindings: {
            people: '<',
            /**
             * What should happen when invite button is clicked.
             * If value is returned, assumes it's a promise, so we can show a loading state for the button.
             */
            onInvite: '&',
        },
        controller: function () {
            const ctrl = this;

            /**
             * Mapping of loading state for the invite button.
             */
            ctrl.isLoading = {
                0: false,
            };

            ctrl.invite = async function invite(person) {
                ctrl.isLoading[person.id] = true;
                try {
                    await ctrl.onInvite({ person });
                } finally {
                    ctrl.isLoading[person.id] = false;
                }
            };
        },
        // language=HTML
        template: `
            <table class="table table-condensed">
                <tr ng-repeat="p in $ctrl.people | filter:{is_participant: false} track by p.id" class="person"
                    data-person-id="{{p.id}}">
                    <td class="person__profile-image">
                        <a ng-href="/{{p.id}}">
                            <img ng-src="{{ p.picture.source|thumb:200:200 }}" alt="{{p.name}}">
                        </a>
                    </td>
                    <td ng-bind="p.name"></td>
                    <td class="text-right align-middle">
                        <button type="button" class="btn"
                                ng-click="$ctrl.invite(p)"
                                ng-class="{ false: 'btn-primary', true: 'btn-default' }[!!p.is_invited]"
                                ng-disabled="p.is_invited || $ctrl.isLoading[p.id]">
                            <span ng-hide="p.is_invited">
                                Invite
                                <span class="fa fa-spin fa-spinner" ng-show="$ctrl.isLoading[p.id]"></span>
                            </span>
                            <span ng-show="p.is_invited">Invitation sent</span>
                        </button>
                    </td>
                </tr>
            </table>
        `,
    });
})();
